import { useState, useEffect } from 'react';
import { Joyride, STATUS, ACTIONS } from 'react-joyride';
import { useAuth } from '../App';

const TOUR_STEPS = [
  {
    target: '[data-testid="app-header"]',
    content: 'Esta es tu barra de navegación. Desde aquí puedes acceder a todas las secciones de LD Finance.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: 'a[href="/dashboard"]',
    content: 'Tu Dashboard te muestra un resumen completo de tu situación financiera: ingresos, gastos, balance y metas.',
    placement: 'bottom',
  },
  {
    target: 'a[href="/transactions"]',
    content: 'Aquí registras tus ingresos y gastos. Puedes hacerlo manual, por voz o con ayuda de la IA.',
    placement: 'bottom',
  },
  {
    target: 'a[href="/debts"]',
    content: 'Gestiona tus deudas: agrega préstamos, tarjetas de crédito y haz seguimiento de tus pagos.',
    placement: 'bottom',
  },
  {
    target: 'a[href="/savings"]',
    content: 'Define metas de ahorro y monitorea tu progreso hacia cada una.',
    placement: 'bottom',
  },
  {
    target: 'a[href="/reports"]',
    content: 'Reportes detallados de tu actividad financiera por mes, categoría y tendencias.',
    placement: 'bottom',
  },
  {
    target: 'a[href="/community"]',
    content: 'Conecta con la comunidad: comparte tips, aprende de otros y participa en retos financieros.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="streak-badge"]',
    content: 'Tu racha muestra cuántos días consecutivos has registrado transacciones. ¡No la pierdas!',
    placement: 'bottom',
    isFixed: true,
  },
];

const joyrideStyles = {
  options: {
    arrowColor: '#1a2332',
    backgroundColor: '#1a2332',
    overlayColor: 'rgba(0, 0, 0, 0.7)',
    primaryColor: '#D4AF37',
    textColor: '#e5e7eb',
    zIndex: 10000,
  },
  tooltip: {
    borderRadius: '12px',
    padding: '16px 20px',
    border: '1px solid #2a3444',
  },
  tooltipContent: {
    fontSize: '14px',
    lineHeight: '1.6',
  },
  buttonNext: {
    backgroundColor: '#D4AF37',
    color: '#0a0e1a',
    borderRadius: '8px',
    fontWeight: 600,
    fontSize: '13px',
    padding: '8px 16px',
  },
  buttonBack: {
    color: '#9ca3af',
    fontSize: '13px',
  },
  buttonSkip: {
    color: '#6b7280',
    fontSize: '12px',
  },
  buttonClose: {
    color: '#9ca3af',
  },
};

const DashboardTutorial = () => {
  const { user } = useAuth();
  const [run, setRun] = useState(false);

  useEffect(() => {
    if (!user) return;
    // Show tutorial only after completing survey and if not seen before
    const tutorialSeen = localStorage.getItem(`tutorial_seen_${user.user_id}`);
    if (user.has_completed_survey && !tutorialSeen) {
      // Small delay to let dashboard render
      const timer = setTimeout(() => setRun(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [user]);

  const handleCallback = (data) => {
    const { status, action } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status) || action === ACTIONS.CLOSE) {
      setRun(false);
      if (user) {
        localStorage.setItem(`tutorial_seen_${user.user_id}`, 'true');
      }
    }
  };

  // Filter steps to only target visible elements
  const visibleSteps = TOUR_STEPS.filter(step => {
    if (step.target === '[data-testid="streak-badge"]') {
      return document.querySelector(step.target);
    }
    return true;
  });

  return (
    <Joyride
      steps={visibleSteps}
      run={run}
      continuous
      showSkipButton
      showProgress
      scrollToFirstStep
      callback={handleCallback}
      styles={joyrideStyles}
      locale={{
        back: 'Atrás',
        close: 'Cerrar',
        last: '¡Listo!',
        next: 'Siguiente',
        skip: 'Saltar tutorial',
      }}
    />
  );
};

export default DashboardTutorial;
